import { GridBreakpointsMediaDown, GridBreakpointsMediaUp } from '@dbi-tools/ui-kit';
import styled, { createGlobalStyle } from 'styled-components';

export const BodyStyled = createGlobalStyle`
  body {
    line-height: 1.5;
    font-weight: 300 !important;
    color: #132122;
    background-color: #faf4ef;
    font-family: 'Objektiv';
    margin: 0;
    letter-spacing: normal;
    overflow-x: hidden;
    overflow-y: inherit !important;

    ${GridBreakpointsMediaUp.md} {
      font-size: 16px;
    }
    ${GridBreakpointsMediaDown.sm} {
      font-size: 16px;
    }
  }
  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }

  .grecaptcha-badge{
    visibility: hidden;
  }
`;

export const MainContentStyled = styled('div')<{
  contentStyle: boolean;
  notFullStyle: boolean;
  withFooterStyle: boolean;
  fullHeightStyle: boolean;
}>`
  ${({ contentStyle }) =>
    contentStyle &&
    `
    padding-top: 30px;
    padding-bottom: 30px;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
  `};

  ${({ notFullStyle, withFooterStyle }) =>
    notFullStyle &&
    `
    ${
      withFooterStyle
        ? `
      ${GridBreakpointsMediaUp.lg} {
          min-height: calc(100vh - 210px);
          top: 130px;
          padding-bottom: 120px;
        }
        ${GridBreakpointsMediaDown.lg} {
          min-height: calc(100vh - 269px);
          top: 104px;
          padding-bottom: 173px;
        }
    `
        : `
      ${GridBreakpointsMediaUp.lg} {
        min-height: calc(100vh - 130px);
        top: 130px;
      }
      ${GridBreakpointsMediaDown.lg} {
        min-height: calc(100vh - 104px);
        top: 104px;
      }
    `
    }
  `};

  ${({ fullHeightStyle }) =>
    fullHeightStyle &&
    `
    min-height: 100vh;
  `};
`;
